import React from 'react';
import Navigation from '../components/Navigation';
import About from '../components/About';
import Footer from '../components/Footer';
import { artistInfo } from '../mock';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-off-black">
      <Navigation />

      {/* Content with top padding */}
      <div className="pt-20 sm:pt-24">
        <About artistInfo={artistInfo} />
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
